import { Input, Output, EventEmitter, Directive, TemplateRef, ContentChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DialogDataWithTemplate } from './dialog.component';
import { DialogComponentInputs, ModalService } from 'src/shared-app-portal/services/modal.service';

@Directive({
  selector: 'lib-dialog',
  exportAs: 'dialog',
  standalone: false
})
export class DialogDirective implements Omit<DialogComponentInputs, 'content'> {
  @Input() yesText: string = 'Yes';
  @Input() noText: string = 'Cancel';
  @Input() header: string = 'Set header';
  @Input() width: number;
  @Input() onOkay: () => Promise<boolean>;
  @Input() hideButtonBar: boolean = false;
  @Input() isAffirmativeWarnColor: boolean;
  @Input() isAffirmativeBasicColor: boolean;
  @Input() isAffirmativeBasic: boolean;

  @Input() minHeightPx?: number;
  /** Whether the user can use escape or clicking on the backdrop to close the modal */
  @Input() disableClose: boolean = true;
  @Input() form: FormGroup;
  @Output() yes = new EventEmitter<boolean>();
  @Output() no = new EventEmitter<boolean>();

  @ContentChild(TemplateRef) template: TemplateRef<any>;

  @ContentChild('extraButtons') extraButtons: TemplateRef<any>;

  constructor(private modalService: ModalService) {}

  /** Returns true if after successfully closed.
   * Called from HTML ex. (click)="infoModal.open()" */
  open = (configOverrides: Partial<DialogDataWithTemplate> = {}): Promise<boolean> =>
    this.modalService
      .openModal(
        {
          ...this,
          content: '' //content not used with directive
        },
        configOverrides
      )
      .then((result) => {
        if (result) {
          this.yes.emit();
        } else if (result === false) {
          this.no.emit();
        }
        return result;
      });
}
